import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Drawer from "../Drawer";
import ImageView from "../ImageView/ImageView";
import { getImageUrl } from "Common/utils/ImageDomain";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import _ from "lodash";
import descriptionSegment from "../../../constants/descriptionStyle.json";
import ReactSelect from "../ReactSelect/ReactSelect";
import { showNotification } from "Common/utils/Notification";
import ImageData from "../customImage/ImageSegment";
import Button from "../ButtonComponent/Button";
import DynamicLink from "../DynamicLink/DynamicLink";
import Modal from "../Modal";
import CustomInput from "../InputFields/CustomInput";
import HomeBannerButton from "../HomeBannerButton";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";

const BannerSegmentOne = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  pageType,
  isEditable,
  versionData,
  segmentId,
  toggleVisiblity,
  segmentType = null,
}) => {
  const btn = data?.buttons ? data?.buttons : [];
  const [buttons, setButtons] = useState(btn);
  const [dynamicLink, setDynamicLink] = useState<any>("");
  const [imageUrl, setImageUrl] = useState(data?.banner_image_url);
  const [headerText, setHeaderText] = useState(data?.banner_header_text);
  const [topHeaderText, setTopHeaderText] = useState(
    data?.banner_header_top_text
  );
  const [imageAlt, setImageAlt] = useState<any>(data?.image_alt_text);
  const [saticStyle, setStaticStyle] = useState<any>();
  const [styleType, setStyleType] = useState("");
  const [index, setIndex] = useState<any>("");
  const [showLink, setShowLink] = useState<any>(false);
  const toggleLink = () => setShowLink(!showLink);
  const [eventData, setEventData] = useState<any>();
  const [showVideo, setShowVideo] = useState(false);
  const [subHeaderText, setSubHeaderText] = useState(
    data?.banner_sub_header_text
  );
  const [isLoading, setIsLoading] = useState<any>(false);

  const [errors, setErrors] = useState<any>({
    banner_image_url: "",
    banner_header_text: "",
    banner_header_top_text: "",
    buttons: buttons?.map(() => ({ label: "", value: "" })),
  });
  const toggle = () => setShowVideo(!showVideo);
  useEffect(() => {
    if (eventData && eventData.media_url) {
      setImageUrl(eventData?.media_url);
      setErrors((prev) => ({
        ...prev,
        ["banner_image_url"]: "",
      }));
    }
  }, [eventData]);

  useEffect(() => {
    if (dynamicLink && dynamicLink !== "") {
      if (index) {
        handleInputChange(index - 1, "value", dynamicLink);
      }
    }
  }, [dynamicLink, index]);

  useEffect(() => {
    if (data && data?.style) {
      setStaticStyle({ label: data?.style, value: data?.style });
      setStyleType(data?.style);
    }
  }, [data]);

  const addButton = () => {
    setButtons([...buttons, { label: "", value: "" }]);
    let newErrors = { ...errors };
    newErrors.buttons.push({ label: "", value: "" });
    setErrors(newErrors);
  };
  const handleStyleData = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
      setStyleType("");
    } else {
      setStyleType(keyValue.value);
    }
    setStaticStyle(keyValue);
  };
  const removeButton = (index) => {
    const updatedButtons = buttons.filter((_, i) => i !== index);
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    updatedErrors.buttons.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleInputChange = (index, field, value) => {
    const updatedButtons = buttons.map((button, i) => {
      if (i === index) {
        button[field] = value;
      }
      return button;
    });
    setButtons(updatedButtons);

    const updatedErrors = { ...errors };
    if (updatedErrors.buttons[index]) {
      updatedErrors.buttons[index][field] = "";
    }
    setErrors(updatedErrors);
  };

  const handleSave = async (pageId, id) => {
    const newErrors = {
      banner_image_url:
        imageUrl.trim() === "" ? "Please enter an image URL." : "",
      banner_header_text:
        headerText.trim() === "" ? "Please enter a banner header." : "",
      banner_header_top_text:
        topHeaderText.trim() === ""
          ? "Please enter a banner header top text."
          : "",
      buttons: buttons?.map(() => ({ label: "", value: "" })),
    };

    buttons.forEach((button, index) => {
      if (!button.label.trim()) {
        newErrors.buttons[index].label = "label is required .";
      }
      if (!button.value.trim()) {
        newErrors.buttons[index].value = "value is required .";
      }
    });

    setErrors(newErrors);

    if (
      !newErrors.banner_image_url &&
      !newErrors.banner_header_text &&
      !newErrors.banner_header_top_text &&
      newErrors?.buttons?.every((error) => !error.label && !error.value)
    ) {
      const payload = {
        segment_type: "home_banner_segments",
        banner_image_url: imageUrl,
        banner_header_top_text: topHeaderText,
        banner_header_text: headerText,
        banner_sub_header_text: subHeaderText,
        buttons,
        style: styleType,
        image_alt_text: imageAlt,
      };

      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/${pageType}/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Banner added successfully!", "success");
        } else {
          showNotification("Something went wrong. Please try again.", "error");
        }
      } catch (e) {
        showNotification(
          "An error occurred while adding the banner. Please try again.",
          "error"
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <div className="mb-4 xl:col-span-12">
          <ToggleSwitch
            selectValue={data?.is_visible}
            versionValue={versionData?.is_visible}
            toggle={() =>
              toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
            }
            label="Is Segment Visible?"
            required={true}
          />
          <div className="flex my-4">
            {versionData?.banner_image_url &&
            imageUrl &&
            imageUrl != versionData?.banner_image_url ? (
              <div className="flex items-center">
                <ImageData
                  isEditable={false}
                  imageLink={imageUrl}
                  setImageLink={setImageUrl}
                  setImageData={setEventData}
                />
                <div className="h-3 ml-3">
                  <Button
                    btnText={"Change"}
                    disabled={true}
                    onClick={() => {
                      toggle();
                      setEventData(undefined);
                    }}
                    isLoading={isLoading}
                    handleSave={handleSave}
                    pageId={pageId}
                    id={segmentId}
                  />
                </div>
              </div>
            ) : null}
            {imageUrl ? (
              <div className="flex items-center">
                <ImageData
                  isEditable={isEditable}
                  imageLink={imageUrl}
                  setImageLink={setImageUrl}
                  setImageData={setEventData}
                />
                <div className="h-3 ml-3">
                  <Button
                    btnText={"Change"}
                    disabled={!isEditable}
                    onClick={() => {
                      toggle();
                      setEventData(undefined);
                    }}
                    isLoading={isLoading}
                    handleSave={handleSave}
                    pageId={pageId}
                    id={segmentId}
                  />
                </div>
              </div>
            ) : (
              <button
                disabled={!isEditable}
                onClick={toggle}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add imageUrl
              </button>
            )}
          </div>
          {errors.banner_image_url && (
            <p className="text-red-500">{errors.banner_image_url}</p>
          )}
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Image Alt Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Image Alt Text"
            value={imageAlt}
            onChange={(e) => setImageAlt(e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.image_alt_text}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Banner Header Top Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Top Header Text"
            value={topHeaderText}
            onChange={(e) => {
              setErrors((prev) => ({
                ...prev,
                ["banner_header_top_text"]: "",
              }));
              setTopHeaderText(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.banner_header_top_text}
            error={errors?.banner_header_top_text}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Banner Header Text"
            name="imageAlt"
            type="text"
            value={headerText}
            onChange={(e) => {
              setErrors((prev) => ({
                ...prev,
                ["banner_header_text"]: "",
              }));
              setHeaderText(e.target.value);
            }}
            error={errors?.banner_header_text}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.banner_header_text}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Banner Sub Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Banner Sub Header Text"
            value={subHeaderText}
            onChange={(e) => setSubHeaderText(e.target.value)}
            error={null}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.banner_sub_header_text}
          />
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="mb-4 xl:col-span-6">
            <label className="inline-block mb-2 text-base font-medium">
              Style
            </label>
            <ReactSelect
              options={descriptionSegment}
              isSearchable={false}
              isMulti={false}
              placeholder={"Please select style type"}
              contentType={saticStyle}
              handleContentChange={handleStyleData}
              name={"style"}
              id={"style-type5"}
              versionData={
                versionData?.style !== saticStyle
                  ? { label: versionData?.style, value: versionData?.style }
                  : null
              }
            />
          </div>
        </div>

        {/* Add Button */}
        <div className="flex justify-end my-4">
          <Button
            btnText="Add Button"
            onClick={addButton}
            disabled={!isEditable}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          />
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {versionData?.buttons?.length > 0 ? <div>Old Data</div> : null}
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Buttons */}
          {versionData?.buttons?.map((button, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <HomeBannerButton
                index={index}
                buttonData={button}
                handleInputChange={handleInputChange}
                removeButton={removeButton}
                buttons={buttons}
                errors={errors}
                isEditable={false}
                isLoading={isLoading}
                pageId={pageId}
                segmentId={segmentId}
                toggleLink={toggleLink}
                setDynamicLink={setDynamicLink}
                setIndex={setIndex}
              />
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {versionData?.buttons?.length > 0 ? <div>New Data</div> : null}
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Buttons */}
          {buttons?.map((button, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <HomeBannerButton
                index={index}
                buttonData={button}
                handleInputChange={handleInputChange}
                removeButton={removeButton}
                buttons={buttons}
                errors={errors}
                isEditable={true}
                isLoading={isLoading}
                pageId={pageId}
                segmentId={segmentId}
                toggleLink={toggleLink}
                setDynamicLink={setDynamicLink}
                setIndex={setIndex}
              />
            </div>
          ))}
        </div>
        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            btnText="Save"
            onClick={null}
            disabled={!isEditable}
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />
          <Button
            btnText="Delete"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
            disabled={!isEditable}
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />
        </div>
      </div>
      <Drawer
        show={showVideo}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showVideo}
            setEventData={setEventData}
            togleImage={toggle}
          />
        </Drawer.Body>
      </Drawer>
      <Modal
        show={showLink}
        onHide={toggleLink}
        id="defaultModal"
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600 flex flex-col h-full"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zink-200 dark:hover:text-red-500"
        >
          <Modal.Title className="text-16">{"Add Link"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          {/* <h5 className="mb-3 text-16">{}</h5> */}
          <div className="h-[400px] text-slate-500 dark:text-zink-200">
            <DynamicLink
              showLink={showLink}
              toggleLink={toggleLink}
              setLink={setDynamicLink}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BannerSegmentOne;
